export const MINOR_WANDS: ITarotCard[] = [
  {
    id: 22,
    rank: "1",
    numeral: "I",
    name: "Ace of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/ace_of_wands.svg",
    wordpressId: "2254",
  },
  {
    id: 23,
    rank: "2",
    numeral: "II",
    name: "Two of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/two_of_wands.svg",
    wordpressId: "2259",
  },
  {
    id: 24,
    rank: "3",
    numeral: "III",
    name: "Three of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/three_of_wands.svg",
    wordpressId: "2264",
  },
  {
    id: 25,
    rank: "4",
    numeral: "IV",
    name: "Four of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/four_of_wands.svg",
    wordpressId: "2269",
  },
  {
    id: 26,
    rank: "5",
    numeral: "V",
    name: "Five of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/five_of_wands.svg",
    wordpressId: "2274",
  },
  {
    id: 27,
    rank: "6",
    numeral: "VI",
    name: "Six of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/six_of_wands.svg",
    wordpressId: "2280",
  },
  {
    id: 28,
    rank: "7",
    numeral: "VII",
    name: "Seven of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/seven_of_wands.svg",
    wordpressId: "2285",
  },
  {
    id: 29,
    rank: "8",
    numeral: "VIII",
    name: "Eight of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/eight_of_wands.svg",
    wordpressId: "2300",
  },
  {
    id: 30,
    rank: "9",
    numeral: "IX",
    name: "Nine of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/nine_of_wands.svg",
    wordpressId: "2305",
  },
  {
    id: 31,
    rank: "10",
    numeral: "X",
    name: "Ten of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/ten_of_wands.svg",
    wordpressId: "2310",
  },
  {
    id: 32,
    rank: "11",
    numeral: "XI",
    name: "Page of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/page_of_wands.svg",
    wordpressId: "2315",
  },
  {
    id: 33,
    rank: "12",
    numeral: "XII",
    name: "Knight of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/knight_of_wands.svg",
    wordpressId: "2320",
  },
  {
    id: 34,
    rank: "13",
    numeral: "XIII",
    name: "Queen of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/queen_of_wands.svg",
    wordpressId: "2325",
  },
  {
    id: 35,
    rank: "14",
    numeral: "XIV",
    name: "King of Wands",
    arcana: "wands",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/wands/king_of_wands.svg",
    wordpressId: "2330",
  },
];
